import { Component, input } from '@angular/core';
import { CdkStep, CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'wma-stepper',
  templateUrl: './stepper.component.html',
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
  imports: [CdkStepperModule, ButtonModule, IconModule, NgTemplateOutlet],
})
export class StepperComponent extends CdkStepper {
  free = input(false);
  selectStep(step: CdkStep) {
    if (this.free()) {
      step.select();
    }
  }
}
